import React from 'react';
import BasicTextFields from './BasicTextFields';
import ImageUploadStep from './ImageUploadStep';

const BasicInfoStep = ({ fields, imgUploadOptions, showImgUploader }) => (
    <>
    <BasicTextFields fields={fields} />
    {showImgUploader && (<ImageUploadStep options={imgUploadOptions} />)}
    </>
);

export default BasicInfoStep;
